import React from "react";
import Profile from "../Profile/Profile";
function ManageAccount() {
  return (
    <div
      
      //   style={{ overflowY: "scroll" }}
    >
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <h4 className="mt-4 mb-3"></h4>
          <Profile />
        </div>
      </section>
    </div>
  );
}

export default ManageAccount;
